var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Subject, SubjectDepthEnum } from '@/models/Subject';
import { Curriculum } from '@/models/Curriculum';
import SelectFilter from '@/components/select-filter/SelectFilter';
import ErrorHandler from '@/support/ErrorHandler';
import { blackKidIcons, blackAreaIcons } from '@/support/Icon';
import Storage from '@/support/Storage';
import AColorPicker from '@/components/AColorPicker/AColorPicker.vue';
let NewSubjectDialog = class NewSubjectDialog extends Vue {
    constructor() {
        super(...arguments);
        this.filters = ['Level', 'Period'];
        this.selectedFilter = [];
        this.selectedAreaColor = '';
        this.selectedAreaIcon = '';
        this.name = '';
        this.formValid = false;
        this.nameRules = [(v) => !!v || 'Name is required'];
    }
    mounted() {
        //
    }
    createSubject() {
        const subject = new Subject({
            name: this.name,
            curriculum: this.curriculum.id,
        });
        if (this.subject === null) {
            subject.color = this.selectedAreaColor;
            subject.icon = this.selectedAreaIcon;
        }
        else {
            subject.parent = this.subject.id;
            if (this.subject.depth === SubjectDepthEnum.TOPIC) {
                const levelFilter = this.selectedFilter.find((filter) => filter.type === 'Level');
                const periodFilter = this.selectedFilter.find((filter) => filter.type === 'Period');
                subject.level = levelFilter !== undefined ? levelFilter.value || '' : '';
                subject.period = periodFilter !== undefined ? periodFilter.value || '' : '';
            }
        }
        subject
            .include(['level', 'period'])
            .create()
            .then((subject) => {
            this.$emit('subjectCreated', { subject, parent: this.subject });
            this.closeDialog();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    resetDefaults() {
        this.formValid = false;
        this.name = '';
        this.selectedAreaColor = '';
        this.selectedAreaIcon = '';
    }
    closeDialog() {
        this.resetDefaults();
        this.$emit('input', false);
    }
    subjectChange(newValue, oldValue) { }
    get subjectType() {
        if (!this.subject) {
            return this.$t('dialogOptions.item.area').toString();
        }
        if (this.subject.depth === 0) {
            return this.$t('dialogOptions.item.topic').toString();
        }
        if (this.subject.depth === 1) {
            return this.$t('dialogOptions.item.subject').toString();
        }
        return this.$t('dialogOptions.item.area').toString();
    }
    get icons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? blackAreaIcons : blackKidIcons;
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], NewSubjectDialog.prototype, "subject", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_b = typeof Curriculum !== "undefined" && Curriculum) === "function" ? _b : Object)
], NewSubjectDialog.prototype, "curriculum", void 0);
__decorate([
    Watch('subject'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], NewSubjectDialog.prototype, "subjectChange", null);
NewSubjectDialog = __decorate([
    Component({
        components: {
            SelectFilter,
            AColorPicker,
        },
    })
], NewSubjectDialog);
export default NewSubjectDialog;
